/**
 * Las semanas con las que se mira el food cost real: de lunes a domingo, en
 * días de Lima.
 *
 * Por semana y no por mes porque es como se compra y como se decide: el
 * pollo sube un jueves y el lunes siguiente ya hay que saberlo. Un mes entero
 * tapa la semana mala con las tres buenas.
 */

/** El lunes de la semana de ese día (`AAAA-MM-DD`), en el calendario de Lima. */
export function lunesDe(dia: string): string {
  const fecha = new Date(`${dia}T12:00:00Z`);
  // getUTCDay: 0 es domingo. El lunes queda seis días atrás de un domingo.
  const atras = (fecha.getUTCDay() + 6) % 7;
  fecha.setUTCDate(fecha.getUTCDate() - atras);
  return fecha.toISOString().slice(0, 10);
}

/** El día que está a tantos días de distancia, hacia adelante o atrás. */
export function sumarDias(dia: string, dias: number): string {
  const fecha = new Date(`${dia}T12:00:00Z`);
  fecha.setUTCDate(fecha.getUTCDate() + dias);
  return fecha.toISOString().slice(0, 10);
}

/** La semana de ese día: de su lunes a su domingo. */
export function semanaDe(dia: string): { desde: string; hasta: string } {
  const desde = lunesDe(dia);
  return { desde, hasta: sumarDias(desde, 6) };
}

/** La semana anterior a la de ese día. */
export function semanaAnteriorA(dia: string): { desde: string; hasta: string } {
  return semanaDe(sumarDias(lunesDe(dia), -7));
}
